var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.214844 10C0.214844 15.5233 4.69176 20 10.2153 20C15.7379 20 20.2148 15.5233 20.2148 10C20.2148 4.47673 15.7379 0 10.2153 0C4.69176 0 0.214844 4.47673 0.214844 10ZM14.4401 5.40984L15.7515 6.72131L9.29644 14.5902L4.6748 10.6584L5.87218 9.25639L8.8348 11.7823L14.4401 5.40984Z",
    fill: "#75B67B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2c7e4117baf24e0d050d34e44e3cd554.svg";
export { ForwardRef as ReactComponent };